import { DocumentContract } from "./document.contract";

export interface MaterialContract {
  uuid: string,
  title: string,
  download_all: boolean,
  product_id: number,
  documents: DocumentContract[]
}